import { useTranslation } from "react-i18next";
export function CheckRTL() {
  const {i18n} = useTranslation()
  const RTL = i18n.language === 'ur' || i18n.language === 'ar';
  return RTL;
}